import React, { useState, useEffect } from 'react';

function OrderForm({ cart, setCart, removeFromCart, updateQuantity, closeCart, isVisible }) {
  const [name, setName] = useState('');
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cartItems = cart.reduce((acc, item) => {
    const existing = acc.find(i => i.id === item.id);
    if (existing) {
      existing.quantity += 1;
    } else {
      acc.push({ ...item, quantity: 1 });
    }
    return acc;
  }, []);

  const totalPrice = cart.reduce((sum, item) => sum + item.price, 0);

  const handleQuantityInput = (id, value) => {
    updateQuantity(id, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting || !name || cart.length === 0) {
      if (!isSubmitting) alert('Заполните имя и добавьте товары!');
      return;
    }

    setIsSubmitting(true);
    const order = {
      name,
      comment,
      items: cartItems,
      totalPrice
    };

    try {
      const response = await fetch('/order', {
 	 method: 'POST',
	 headers: {
	    'Content-Type': 'application/json',
	    'X-CSRF-Token': 'simple-csrf-token',
	 },
 	 body: JSON.stringify(order),
      });
      if (response.ok) {
        alert('Заказ отправлен!');
        setName('');
        setComment('');
        setCart([]);
        closeCart();
      } else {
        alert('Ошибка при отправке заказа.');
      }
    } catch (error) {
      alert('Ошибка: ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const form = document.querySelector('.order-form');
    if (isVisible && form) {
      form.classList.add('active');
    } else if (form) {
      form.classList.remove('active');
    }
  }, [isVisible]);

  return (
    <div className="order-form">
      <div className="order-form-header">
        <h2>Корзина</h2>
        <button className="close-btn" onClick={closeCart}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 6l12 12M18 6l-12 12" />
          </svg>
        </button>
      </div>
      {cart.length > 0 ? (
        <div>
          <ul className="cart-items">
            {cartItems.map((item) => (
              <li key={item.id}>
                <span>{item.name} - {item.price} ₽</span>
                <div className="quantity-controls">
                  <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>
                    <img src="/icons/minus.svg" alt="Minus" className="icon minus-icon" />
                  </button>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityInput(item.id, e.target.value)}
                    min="0"
                    max="75"
                    className="quantity-input"
                  />
                  <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>
                    <img src="/icons/plus.svg" alt="Plus" className="icon" />
                  </button>
                </div>
                <button
                  className="remove-btn"
                  onClick={() => removeFromCart(item.id)}
                >
                  <img src="/icons/trash.svg" alt="Trash" className="icon" />
                </button>
              </li>
            ))}
          </ul>
          <p><strong>Итого: {totalPrice} ₽</strong></p>
          <form onSubmit={handleSubmit}>
            <label>
              Имя:
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </label>
            <label>
              Комментарий (не обязательно):
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows="3"
                placeholder="Ваши пожелания к заказу"
                style={{ width: '100%', boxSizing: 'border-box', height: '60px', resize: 'none' }}
              />
            </label>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Отправка...' : 'Отправить заказ'}
            </button>
            <p className="order-note">
              Заказ забирать и оплачивать в магазине в течение недели. Он будет собран и стоять готовым.
            </p>
          </form>
        </div>
      ) : (
        <p>Корзина пуста</p>
      )}
    </div>
  );
}

export default OrderForm;
